import { render, staticRenderFns } from "./AddedProduct.vue?vue&type=template&id=972eda0a&scoped=true"
import script from "./AddedProduct.vue?vue&type=script&lang=js"
export * from "./AddedProduct.vue?vue&type=script&lang=js"
import style0 from "./AddedProduct.vue?vue&type=style&index=0&id=972eda0a&prod&scoped=true&lang=css"
import style1 from "./AddedProduct.vue?vue&type=style&index=1&id=972eda0a&prod&lang=scss"
import style2 from "./AddedProduct.vue?vue&type=style&index=2&id=972eda0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972eda0a",
  null
  
)

export default component.exports